import { useContext } from 'react';

import { UserSettingsContext } from './user-settings-context';

export const useSettingsOpenOrigin = () => {
  const { openOrigin } = useContext(UserSettingsContext);

  return openOrigin;
};
